<template>
    <div v-html="renderedContent"></div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        markdownData: "" // 后台返回的 HTML 数据
      };
    },
    computed: {
      renderedContent() {
        return this.parseMarkdownContent(this.markdownData);
      }
    },
    methods: {
      parseMarkdownContent(htmlContent) {
        // 使用正则表达式匹配表格部分
        const tableRegex = /<p>(\|[^|]+)+\|\s*<\/p>/g;
        const matches = htmlContent.match(tableRegex);
        console.log('提取到的表格部分：', matches);
        if (!matches) return htmlContent; // 如果没有表格，直接返回原始内容
  
        // 提取表格内容
        const tableContent = matches.join('\n').trim();
        const rows = tableContent.split('<p>').join('').split('\n').map(row => row.trim());
  
        // 解析每一行
        const parsedRows = rows.map(row => {
          const cols = row.split('||').map(col => col.trim().replace(/^\|/, '').replace(/\|$/, ''));
          return cols;
        });
  
        // 生成 HTML 表格
        let htmlTable = '<table border="1">';
        parsedRows.forEach((rowData, index) => {
          htmlTable += '<tr>';
          rowData.forEach(cellData => {
            htmlTable += index === 0 ? `<th>${cellData}</th>` : `<td>${cellData}</td>`;
          });
          htmlTable += '</tr>';
        });
        htmlTable += '</table>';
  
        // 替换原始字符串中的表格部分为生成的 HTML 表格
        const nonTableContent = htmlContent.replace(tableRegex, '').trim();
  
        // 将非表格内容和HTML表格合并
        return nonTableContent + '<br><br>' + htmlTable;
      }
    },
    mounted() {
      // 模拟从后台获取数据
      this.markdownData = `
  <h4>二、市场结构判断</h4>
  <p>| 指标       | 数值      | 市场结构特征                  |
  |------------|----------|-----------------------------|
  | CR4        | 78.9%    | <strong>寡头垄断型市场</strong>（CR4&gt;60%）|
  | HHI        | 1,881    | 中度集中（HHI 1,500-2,500）  |</p>
  <p><strong>结论</strong>：中国CT设备市场属于<strong>高集中度寡头垄断结构</strong>，头部4家厂商占据近80%市场份额，但HHI显示竞争强度高于完全垄断市场，存在多强争霸格局。</p>
  <hr />
  <h4>三、竞争动态分析（波特五力模型）</h4>
  <ol>
  <li><p><strong>新进入者威胁</strong>（★★☆）</p>
  <ul>
  <li><strong>壁垒</strong>：高研发投入（CT设备技术门槛）、品牌认知度（医院偏好进口品牌）、渠道资源（公立医院采购体系）。</li>
  <li><strong>机会点</strong>：联影等本土企业通过国产替代政策突破垄断。</li>
  </ul>
  </li>
  <li><p><strong>替代品威胁</strong>（★☆☆）</p>
  <ul>
  <li>MRI、超声等其他影像设备难以替代CT的核心功能（快速断层扫描、急诊应用）。</li>
  </ul>
  </li>
  <li><p><strong>供应商议价能力</strong>（★★☆）</p>
  <ul>
  <li>核心部件（如X射线管、探测器）依赖进口，但联影已实现探测器国产化。</li>
  </ul>
  </li>
  <li><p><strong>买方议价能力</strong>（★★★）</p>
  <ul>
  <li>公立医院采购占主导，政府集采政策（如安徽集采降价84%）大幅压低价格。</li>
  </ul>
  </li>
  <li><p><strong>同业竞争强度</strong>（★★★）</p>
  <ul>
  <li>头部企业份额咬合：联影（26.8%）与GE（21.6%）差距仅5.2%，西门子（17.1%）与东软（13.4%）争夺第三梯队。</li>
  </ul>
  </li>
  </ol>
  `;
    }
  };
  </script>
  
  <style scoped>
  table {
    width: 50%;
    border-collapse: collapse;
    margin: 20px 0;
  }
  th, td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: left;
  }
  th {
    background-color: #f2f2f2;
  }
  </style>